import router from "@/router";
import Popup from "@/entity/Popup";
import store from "@/store";
import {api} from '@/services/Api'
import {USE_LOCAL_MENU} from "@/router/Menu";

class NotificationManager {

    publicPath = process.env.BASE_URL
    userHasInteracted = false;

    defaultAudio: any;
    errorAudio: any;
    cashAudio: any;
    cashFailed: any;
    channel = new BroadcastChannel('notifications');

    constructor() {
        this.defaultAudio = new Audio(this.publicPath + 'sounds/pop.mp3');
        this.errorAudio = new Audio(this.publicPath + 'sounds/error.mp3');
        this.cashAudio = new Audio(this.publicPath + 'sounds/cash.mp3');
        this.cashFailed = new Audio(this.publicPath + 'sounds/cash_failed.mp3');
        this.handleMessage = this.handleMessage.bind(this);
        this.channel.addEventListener('message', this.handleMessage)

        window.addEventListener('click', this.markAsInteracted);
        window.addEventListener('keydown', this.markAsInteracted);
        window.addEventListener('touchstart', this.markAsInteracted);
    }

    markAsInteracted() {
        this.userHasInteracted = true;
        window.removeEventListener('click', this.markAsInteracted);
        window.removeEventListener('keydown', this.markAsInteracted);
        window.removeEventListener('touchstart', this.markAsInteracted);
    };

    public destroy() {
        this.channel.removeEventListener('message', this.handleMessage);
        this.channel.close();
        window.removeEventListener('click', this.markAsInteracted);
        window.removeEventListener('keydown', this.markAsInteracted);
        window.removeEventListener('touchstart', this.markAsInteracted);
    }

    play(type = '') {
        if (!this.userHasInteracted) {
            return
        }
        // console.log('try play')
        if (!localStorage.getItem('notification_played')) {
            // console.log('play')
            localStorage.setItem('notification_played', 'true');
            try {
                switch (type) {
                    case 'cash': {
                        // console.log('1')
                        this.cashAudio.play()
                        break;
                    }
                    case 'error': {
                        // console.log('2')

                        this.errorAudio.play()
                        break;
                    }
                    case 'cash_failed': {
                        // console.log('3')

                        this.cashFailed.play()
                        break;
                    }
                    default: {
                        // console.log('4')

                        this.defaultAudio.play()
                        break
                    }
                }
            } catch (e) {
            }
            setTimeout(() => {
                localStorage.removeItem('notification_played');
            }, 5000);
        } else {
            // console.log('localstoraged')
        }
    }

    /**
     * Traitement d'une notif d'ESCALATION : critique cote manager.
     *   1. Push dans le dropdown cloche (badge rouge, persistante jusqu'a clic)
     *   2. Popup danger keepalive (ne disparait pas tout seul)
     *   3. Son error
     * Toujours execute (ignore le mode DATA) car un manager ne peut pas louper ca.
     */
    handleEscalation(data: any) {
        const conversationId = data.conversationId || data.data?.conversationId || null
        const title = data.title || 'Escalade — intervention requise'
        const content = data.content || data.reason || 'Une conversation necessite un agent humain'

        const notif: any = {
            id: 'escalation-' + (conversationId || Date.now()),
            title,
            content,
            subtitle: 'Escalade IA',
            photo: 'fad fa-triangle-exclamation',
            type: 'ESCALATION',
            category: 'CHAT',
            color: 'danger',
            route: conversationId
                ? {name: 'chat-index', query: {conversation: conversationId}}
                : {name: 'chat-escalations'},
            createdAt: new Date(),
        }
        store.commit('pushNotification', notif)

        new Popup(title, content, 'danger', 'fad fa-triangle-exclamation', true)
        this.play('error')
    }

    handleMessage(message: any) {
        if (message && message.data && message.data.data) {
            message = message.data
        }
        const data = message.data;
        const mode = data?.mode;

        // Dispatch store TOUJOURS (y compris mode=DATA = mode "in-app silent" des
        // conversations en auto). Sans ca, Conversation.vue et RiskStatesPanel.vue
        // ne recoivent jamais le signal pour refresh, meme avec FCM actif.
        if (data?.type === 'MESSAGE_RECEIVED' || data?.type === 'WHATSAPP_MESSAGE_RECEIVED' || data?.type === 'ESCALATION') {
            store.commit('notificationReceived', {
                type: data.type,
                conversationId: data.conversationId || null,
                messageId: data.messageId || null,
                direction: data.direction || null,
                mode,
                raw: data,
            });
        }

        // ESCALATION : critique pour les managers, on ne SKIP jamais (meme en mode
        // DATA quand rate-limite). Push notification dropdown + popup + son AVANT
        // le return potentiel du mode DATA.
        if (data?.type === 'ESCALATION') {
            this.handleEscalation(data)
            return
        }

        // Apres dispatch store, on peut skipper les UI side-effects (Popup, son,
        // badge page autre) pour les notifs mode DATA. Elles sont par definition
        // silencieuses cote OS, mais la donnee est deja chez le store.
        if (mode === 'DATA') {
            return
        }

        let route = null
        let href = null;
        try {
            route = JSON.parse(data.route)
            const href = router.resolve(route)?.href;
            delete (data.route)
        } catch (e) {
        }


        switch (data.type) {
            case 'MESSAGE_RECEIVED':
            case 'WHATSAPP_MESSAGE_RECEIVED': {
                data.subtitle = 'Whatsapp'
                data.photo = 'fab fa-whatsapp'
                if (route && router.currentRoute.name !== route.name) {
                    new Notification(data)
                    if (data.mode !== 'SILENT') {
                        notificationManager.play()
                    }
                }
                break;
            }
            case 'ENGINE_GENERATED': {
                let color = data.color ? data.color : 'secondary';
                let message = data.message ? data.message : 'Un moteur de calcul a été généré'
                let title = data.title ? data.title : 'UNKNOW BRANCH'
                let icon = data.icon ? data.icon : 'fad fa-thumbs-up'
                new Popup(title, message, color, icon);
                notificationManager.play()
                break;
            }
            case 'CHECKOUT_FAILED': {
                let color = data.color ? data.color : 'danger';
                let message = data.message ? data.message : 'Un paiement a échoué'
                let title = data.title ? data.title : 'Echec paiement'
                new Popup(title, message, color, 'fad fa-exclamation-triangle', false);
                notificationManager.play('cash_failed')
                break;
            }
            case 'ENGINE_GENERATION_ERROR': {
                let color = data.color ? data.color : 'danger';
                let message = data.message ? data.message : "La génération d'un moteur de calcul a échou"
                let title = data.title ? data.title : 'Echéc génération de moteur'
                new Popup(title, message, color, 'fad fa-exclamation-triangle', false);
                notificationManager.play('error')
                break;
            }
            case 'PAYMENT_SUCCEED': {
                let color = data.color ? data.color : 'success';
                let message = data.message ? data.message : 'Un paiement a été effectué'
                let title = data.title ? data.title : 'Paiement Effectué'
                new Popup(title, message, color, 'fad fa-cash-register');
                notificationManager.play('cash')
                break;
            }
            case 'CONTRACT_EMITTED': {
                let color = data.color ? data.color : 'success';
                let message = data.message ? data.message : 'Emission'
                let title = data.title ? data.title : 'Un contract a été émis'
                new Popup(title, message, color, 'fad fa-cash-register');
                notificationManager.play()
                break;
            }
            case 'AVENANT_EMITTED': {
                let color = data.color ? data.color : 'success';
                let message = data.message ? data.message : 'Emission'
                let title = data.title ? data.title : 'Un avenant a été émis'
                new Popup(title, message, color, 'fad fa-cash-register');
                notificationManager.play()
                break;
            }
            case 'MENU_UPDATED': {
                // Refresh effectif depuis auth (le getter seul était un no-op).
                // USE_LOCAL_MENU : on ignore le push serveur, le menu local fait foi.
                if (!USE_LOCAL_MENU) {
                    api.get(api.auth, 'menu/list').then((res: any) => {
                        if (res?.data?.menu) {
                            store.state.mainStore.menus = res.data.menu
                            localStorage.setItem('menus', JSON.stringify(res.data.menu))
                        }
                    }).catch(() => {})
                }
                break;
            }
            case 'CERTIFICATE_COUNT_UPDATED': {
                store.commit('comparatorStore/REPLACE_OR_ADD_AUTO_CERTIFICATE', JSON.parse(data.data))
                break;
            }
            default: {
                console.log('UNKNOWN NOTIFICATION TYPE ' + data.type)
                console.log(data)
                let color = data.color ? data.color : 'secondary';
                let message = data.message ? data.message : 'Aucun Message'
                let title = data.title ? data.title : 'Aucun Titre'
                let keepalive = data.keepalive ? data.keepalive : false
                let uuid = data.uuid ? data.uuid : null
                let buttons = data.buttons ? data.buttons : null
                new Popup(title, message, color, 'fad fa-exclamation-triangle', keepalive, href, buttons, uuid);
                notificationManager.play('error')
                break;
            }
        }
        return true
    }
}

export const notificationManager = new NotificationManager()
window.addEventListener('beforeunload', () => {
    notificationManager.destroy();
});